import { GLI_Back_Button, GLI_Container, GLI_NameGroupLesson, groupLessonItemVariants } from "./GroupLessonItem.styled";
import { ICON_BACK_COMPONENT } from "../../../../../../Icons";
import * as React from "react";
import { ServiceName } from "../../../../../../../../constants";
import { GrandChartGroupLessonStore } from "../../../../../../../../stores/grand-charts/grand-chart-group-lesson.store";
import { ProgressLessonGroup } from "./ProgressLessonGroup";
import { Lessons } from "./Lessons";
import { forwardRef } from "react";

interface GroupLessonItemProps {
	isFirstGroupLesson: boolean;
	isShowBackButton: boolean;
	isSelected: boolean;
	service: ServiceName;
	groupLessonStore: GrandChartGroupLessonStore;
	onBackToGrandChart: () => void;
}

export const GroupLessonItem = forwardRef<HTMLDivElement, GroupLessonItemProps>(
	(
		{
			isFirstGroupLesson = false,
			isShowBackButton = false,
			isSelected = false,
			service,
			groupLessonStore,
			onBackToGrandChart,
		},
		ref,
	) => {
		return (
			<GLI_Container ref={ref} $isSelected={isSelected} $service={service} variants={groupLessonItemVariants}>
				{isShowBackButton && (
					<GLI_Back_Button onClick={onBackToGrandChart}>
						<ICON_BACK_COMPONENT />
					</GLI_Back_Button>
				)}

				<GLI_NameGroupLesson>{groupLessonStore.name}</GLI_NameGroupLesson>
				<ProgressLessonGroup service={service} groupLessonStore={groupLessonStore} />
				<Lessons isFirstGroupLesson={isFirstGroupLesson} service={service} groupLessonStore={groupLessonStore} />
			</GLI_Container>
		);
	},
);
